document.addEventListener('DOMContentLoaded', () => {
  const productIds = RecentlyViewed.getProducts();

  if (!productIds.length) return;

  const searchQuery = productIds.map(id => `id:${id}`).join(' OR ');

  fetch(`/search?q=${encodeURIComponent(searchQuery)}&type=product&view=recently-viewed`)
    .then(res => res.text())
    .then(html => {
      document.querySelector('#recently-viewed-grid').innerHTML = html;
    })
    .catch(err => console.error('Error loading recently viewed:', err));
});



